import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';
import styles from './CreateTaxInvoicePopUp.module.css';
import Button from '../../../components/common/button/Button';
import {useAlert} from "../../../components/common/error/AlertContext";
import {
    ClientListResponseData,
    CreateRegularTaxInvoiceRequest,
} from "../../../types/admin";
import {
    createRegularAdminTaxInvoiceAPI, getApprovedClientListAPI
} from "../../../services/admin";

interface CreateTaxInvoicePopUpProps {
    isOpen: boolean;
    onClose: () => void;
}

//세금계산서 정기발행 생성 팝업
const CreateRegularTaxInvoicePopUp: React.FC<CreateTaxInvoicePopUpProps> = ({
                                                                         isOpen,
                                                                         onClose
                                                                     }) => {
    const [requestData, setRequestData] = useState<CreateRegularTaxInvoiceRequest>({
        clientId: 0,
        day: 0,
        amount: 0
    });
    const [clients, setClients] = useState<ClientListResponseData[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const {showAlert} = useAlert();

    const fetchPayments = async () => {
        try {
            // 승인된 클라이언트 목록 조회 API
            const response = await getApprovedClientListAPI();
            setClients(response);
        } catch (error) {
            console.error('Error fetching clients:', error);
        }
    };

    useEffect(() => {
        fetchPayments();
    }, []);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (isLoading) return;
        //입력 필수값 확인
        if (requestData.clientId === 0) {
            showAlert('클라이언트를 선택해주세요.', "error");
            return;
        }
        if (requestData.day === 0) {
            showAlert('정기결제일을 선택해주세요.', "error");
            return;
        }
        if (requestData.amount <= 0) {
            showAlert('총액은 0 이상이어야 합니다.', "error");
            return;
        }

        setIsLoading(true);
        try {
            await createRegularAdminTaxInvoiceAPI(requestData);
            setRequestData({
                clientId: 0,
                day: 0,
                amount: 0
            });
            onClose();
            showAlert('세금계산서 정기발행 설정되었습니다.', "info");
            fetchPayments();
        } catch (error) {
            console.error('정기발행 설정 실패:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Modal
                isOpen={isOpen}
                onRequestClose={onClose}
                className={styles.modal}
                overlayClassName={styles.overlay}
            >
                <div className={styles.modalContent}>
                    <div className={styles.header}>
                        <h2>세금계산서 정기발행 설정</h2>
                        <button onClick={onClose} className={styles.closeButton} type="button" aria-label="Close">×
                        </button>
                    </div>
                    <p className={styles.warning}>개인정보 수집·이용 미동의 클라이언트는 <br/> 정기발행이 진행되지 않습니다.</p>
                    <form onSubmit={handleSubmit} className={styles.form}>
                        <div className={styles.formGroup}>
                            <label>클라이언트</label>
                            {/*대상 결제 선택*/}
                            <select
                                value={requestData.clientId}
                                onChange={(e) => {
                                    const selectedClientId = parseInt(e.target.value);
                                    setRequestData(prev => ({
                                        ...prev,
                                        clientId: selectedClientId
                                    }))
                                }}
                                className={styles.select}
                                disabled={isLoading}
                            >
                                <option value={0}>선택해주세요</option>
                                {clients.map(client => (
                                    <option key={client.clientId} value={client.clientId}>
                                        {client.companyName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className={styles.formGroup}>
                            <label>총액 (부가세 포함)</label>
                            <input
                                type="number"
                                value={requestData.amount === 0 ? '' : requestData.amount}
                                onChange={(e) => {
                                    const value = parseInt(e.target.value) || 0;
                                    setRequestData(prev => ({
                                        ...prev,
                                        amount: value
                                    }));
                                }}
                                min="0"
                                className={styles.input}
                                disabled={isLoading}
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label>정기 결제일 (1~27)</label>
                            <input
                                type="number"
                                value={requestData.day === 0 ? '' : requestData.day}
                                onChange={(e) => {
                                    const value = parseInt(e.target.value) || 0;
                                    setRequestData(prev => ({
                                        ...prev,
                                        day: value
                                    }));
                                }}
                                min="1"
                                max="27"
                                className={styles.input}
                                disabled={isLoading}
                            />
                        </div>
                        {/*요청 생성 버튼*/}
                        <Button
                            type="submit"
                            variant="primary"
                            size="large"
                            fullWidth
                            disabled={isLoading}
                        >
                            설정
                        </Button>
                    </form>
                </div>
            </Modal>
        </>
    );
};

export default CreateRegularTaxInvoicePopUp;